import { HttpClient } from '@angular/common/http';
import { HostListener, Injectable } from '@angular/core';
import { BQXConfiguration } from 'bqx-ui-common';
import { envTheme } from './models/env-theme/env-theme';
import { IAppConfig } from './models/shared/app-config.model';
import { Global } from './models/shared/app-global.model';


// Sr No.     Date         WorkItem ID       Modified By             Change/Description
// 01         01/06/2022   4325916           Ritesh Sinha            Created new service class to load enviornmnet configuration
//

/**
 * @class AppConfig
 * @description To initialize configuration attributes
 */
@Injectable()
export class AppConfig {
    static settings: IAppConfig;
    static appGuid: string;
    static loadedAppConfig: boolean;
    static isAppConfigRoute = false;

    /**
     * Creates an instance of AppConfig.
     */
    constructor(private http: HttpClient) { }

    /**
     * @description to load attributes from configuration file
     * @type public method
     * @param
     * @returns
     */
    load() {
        console.log('AppConfig load started.');
        const jsonFile = 'assets/config/config.json';
        return new Promise<void>((resolve, reject) => {
            this.http.get(jsonFile)
                .toPromise()
                .then(
                    (response: any) => {
                        AppConfig.settings = <IAppConfig>response;
                        BQXConfiguration.setConfig = AppConfig.settings.bqxCoreConfig;
                        Global.currentTheme = new envTheme(document);
                        Global.sessionId = crypto.randomUUID();
                        Global.screenWidth = window.innerWidth;
                        resolve();
                    }
                ).catch(
                    (response: any) => {
                        console.log('AppConfig loading Error: ' + JSON.stringify(response));
                        reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
                    }
                );
        });
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        Global.screenWidth = window.innerWidth;
    }
}
